<template>
	<div class="">
		<v-card-title v-if="title" class="d-flex align-center">
			{{ title }}
			<v-icon color="info" @click="load">$reload</v-icon>
		</v-card-title>
		<v-card-title class="ptxxx-0">
			<v-form @submit.prevent="search" class="form-inline">
				<v-row class="">
					<v-col cols="12" class="d-flex flex-wrap align-center">
						<v-text-field
							outlined
							class="search-field-name mr-2"
							dense
							v-model="query.name"
							label="名称"
							hide-details
						/>
						<v-text-field
							outlined
							class="search-field-short mr-2"
							dense
							v-model="query.code"
							label="编码"
							hide-details
						/>
						<v-select
							outlined
							class="mr-2"
							dense
							label="状态"
							v-model="query.status"
							:items="refs['CuppingScoreStatus']"
							hide-details
							clearable
						></v-select>
						<v-chip
							v-if="query.bean_id"
							class="mr-2"
							size="small"
							closable
							color="secondary"
							variant="tonal"
							@click:close="clearBeanFilter"
						>
							生豆 #{{ query.bean_id }}
						</v-chip>
						<v-btn color="primary" size="large" class="mr-2" @click="search">查询</v-btn>
						<v-icon class="mr-2" v-if="queryPairs.length" @click="reset">$close</v-icon>
					</v-col>
				</v-row>
			</v-form>
		</v-card-title>

		<v-data-table-server
			:headers="headers"
			:items="objects"
			@update:options="load"
			:items-length="parseInt(total)"
			:loading="loading"
			:show-select="showSelect"
			:single-select="singleSelect"
			v-model="selected"
			multi-sort
		>
			<template v-slot:top>
				<slot name="batchActions" v-bind:selected="selected"></slot>
			</template>

			<template #item.bean_id="{ item }">
				<template v-if="item.bean">
					{{ item.bean.name }}
				</template>
			</template>
			<template v-slot:item.cupping_id="{ item }">
				<template v-if="item.cupping">
					{{ item.cupping.name }}({{ item.cupping.id }}) {{ item.cupping.location }}
				</template>
			</template>
			<template #item.user_id="{ item }">
				<template v-if="item.user">
					{{ item.user.nickname }}
				</template>
				<template v-else>
					<span class="text-medium-emphasis">—</span>
				</template>
			</template>
			<template #item.cupping_time="{ item }">
				<template v-if="item.cupping && item.cupping.created_at">
					{{ $formatTime(item.cupping.created_at) }}
				</template>
				<span v-else class="text-medium-emphasis">—</span>
			</template>
			<template #item.created_at="{ item }">
				<template v-if="item.created_at">
					{{ $formatTime(item.created_at) }}
				</template>
				<span v-else class="text-medium-emphasis">—</span>
			</template>
			<template v-slot:item.total="{ item }">
				{{ item.total }}
			</template>
			<template v-slot:item.status="{ item }">
				<enum-chip kind="status" :value="item.status" />
			</template>
			<template v-slot:item.owner="{ item }">
				{{ item.owner }}
				<template v-if="item.owner == 'other'">
					{{ item.otherowner }}
				</template>
			</template>
			<template v-slot:item.process="{ item }">
				<template v-if="item.process == 'other'">
					{{ item.otherprocess }}
				</template>
				<template v-else>
					<span>{{ item.process }}</span>
				</template>
			</template>

			<template v-slot:item.action="{ item }">
				<slot name="actions" v-bind="{ item }"></slot>
			</template>

			<template v-slot:footer>
				<slot name="batchActions" v-bind="{ selected }"></slot>
			</template>
		</v-data-table-server>
	</div>
</template>

<script>
import EnumChip from '../common/EnumChip.vue'
import { clone, valuesIn, toPairsIn, filter, intersection } from 'lodash-es'
import qs from 'qs'

export default {
	components: { EnumChip },
	props: {
		initQuery: { type: Object, default: null },
		title: { type: String, default: null },
		showSelect: { type: Boolean, default: false },
		singleSelect: { type: Boolean, default: true },
		headers: {
			type: Array,
			default: () => [
				{ title: '#', value: 'id' },
				{ title: '豆', align: 'left', sortable: true, value: 'bean_id' },
				{ title: '杯测', align: 'left', sortable: true, value: 'cupping_id' },
				{ title: '杯测人', align: 'left', sortable: true, value: 'user_id' },
				{ title: '杯测时间', align: 'left', sortable: false, value: 'cupping_time' },
				{ title: '评分时间', align: 'left', sortable: true, value: 'created_at' },
				{ title: '评分', sortable: true, value: 'total' },
				{ title: '状态', value: 'status' },
				{ title: '', align: 'left', sortable: false, value: 'action' }
			]
		}
	},
	data() {
		const qps = qs.parse(location.search, { ignoreQueryPrefix: true })
		return {
			query: qps,
			currentQuery: {}, //当前结果的查询条件
			objects: [],
			total: 0,
			loading: false,
			options: null, //当前选项（保持）
			refs: {},
			selected: [],
			errors: {}
		}
	},
	mounted() {
		if (this.initQuery) {
			this.query = clone(this.initQuery)
		}
		this.$api.common.meta('cupping', 'CuppingScoreStatus', (response) => {
			this.refs = response
		})
		this.load()
	},
	computed: {
		queryValues() {
			return filter(valuesIn(this.query), (e) => !!e)
		},
		currentQueryValues() {
			return filter(valuesIn(this.currentQuery), (e) => !!e)
		},
		queryPairs() {
			return filter(toPairsIn(this.query), (e) => !!e[1])
		}
	},
	watch: {},
	methods: {
		search() {
			if (
				this.queryValues.length !== this.currentQueryValues.length ||
				intersection(this.queryValues, this.currentQueryValues).length !== this.queryValues.length
			) {
				//条件变化
				if (this.options.page === 1) {
					//当前如果是第一页，手动触发
					this.load()
				} else {
					this.options.page = 1 //当前不是第一页，修改后通过watcher触发
				}
			} else {
				//条件没变，忽略
			}
		},
		reset() {
			this.query = {}
		},
		clearBeanFilter() {
			delete this.query.bean_id
			this.search()
		},
		load(options = null) {
			if (!this.options) this.options = {}
			if (options) {
				this.options = options
			}

			let { sortBy, page, itemsPerPage } = this.options
			this.loading = true
			let qwp = clone(this.query)
			qwp.pageno = page
			qwp.pagesize = itemsPerPage
			qwp.sortBy = 'id'
			qwp.sortDesc = 'desc'
			if (sortBy && sortBy.length > 0) {
				qwp.sort = sortBy.map((e) => `${e.key} ${e.order}`).join(',')
				qwp.sortBy = sortBy[0]['key']
				qwp.sortDesc = sortBy[0]['order']
			}

			this.currentQuery = clone(this.query)
			this.$api.cupping.searchScore(
				qwp,
				(response) => {
					this.objects = response.objects
					this.total = response.total
					this.loading = false
				},
				(error) => {
					this.errors = error.message
					this.loading = false
				}
			)
		}
	}
}
</script>

<style scoped>
.silent td {
	color: rgba(3, 3, 3, 0.5) !important;
}
</style>
